import { FeatureRollout } from '@ms/yammer-data/dist/state/types';
import { useIsFeatureRolloutEnabled } from '@ms/yammer-hooks/dist/featureRollouts';

import { UseUIFeatureCheck } from '../types';

export const useIsChatEnabled: UseUIFeatureCheck = () => useIsFeatureRolloutEnabled(FeatureRollout.TeamsChatButton);
